import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    loading: false,
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    //form specific:
    consoleUserData: {},

    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,

    consoleUserWasCreated: false,
    consoleUserWasEdited: false,
    consoleUserWasDeleted: false,

    error: undefined
};

const consoleUsersReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.CONSOLE_USER_SEARCH_REQUEST:
            return {
                ...state,
                loading:true
            };
        case actionTypes.CONSOLE_USER_SEARCH_SUCCESS:
            return {
                ...state,
                loading:false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.GET_CONSOLE_USER_REQUEST:
            return {
                ...state,
                loading:true,
            };
        case actionTypes.GET_CONSOLE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                consoleUserData: payload,
            };
        case actionTypes.DELETE_CONSOLE_USER_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true
            };
        case actionTypes.DELETE_CONSOLE_USER_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                consoleUserWasDeleted: true
            };
        case actionTypes.DELETE_CONSOLE_USER_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                consoleUserWasDeleted: false
            };
        case actionTypes.EDIT_CONSOLE_USER_REQUEST:
            return {
                ...state,
                loadingEditRequest: true
            };
        case actionTypes.EDIT_CONSOLE_USER_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                consoleUserWasEdited: true
            };
        case actionTypes.EDIT_CONSOLE_USER_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                consoleUserWasEdited: false
            };
        case actionTypes.CREATE_CONSOLE_USER_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true
            };
        case actionTypes.CREATE_CONSOLE_USER_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                consoleUserWasCreated: true
            };
        case actionTypes.CREATE_CONSOLE_USER_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                consoleUserWasCreated: false
            };
        case actionTypes.RESET_CONSOLE_USER_FORM:
            return {
                ...state,
                consoleUserData: {},
                loadingCreateRequest: false,
                loadingEditRequest: false,
                loadingDeleteRequest: false,
                consoleUserWasCreated: false,
                consoleUserWasEdited: false,
                consoleUserWasDeleted: false,
                error: undefined
            };
        default:
            return state;
    }
};

export default consoleUsersReducer;